import { IconDefinition } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export interface Feature {
  title: string
  description: string
  icon: IconDefinition
}

interface FeatureCardProps {
  feature: Feature
}

export default function FeatureCard({
  feature,
}: FeatureCardProps): JSX.Element {
  return (
    <div
      style={{
        background:
          'linear-gradient(52.39deg, rgba(39, 39, 39, 0.6) 0%, rgba(30, 30, 30, 0.6) 100%)',
      }}
      className="bg-gray-300 bg-opacity-20 rounded-xl p-6 pb-12"
    >
      <FontAwesomeIcon icon={feature.icon} className="text-v5-red text-3xl" />

      <h1 className="font-semibold text-xl mt-2 mb-4">{feature.title}</h1>

      <p className="text-white text-opacity-60">{feature.description}</p>
    </div>
  )
}
